import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
	const location = useLocation();
	const previousPathname = useRef(location.pathname);

	useEffect(() => {
		const pathnameChanged = previousPathname.current !== location.pathname;
		previousPathname.current = location.pathname;
		if (location.hash) return;
		// The Support page keeps its state in the query string (tabs, panel steps, selected topic), so changing it must not jump to the top.
		if (!pathnameChanged && location.pathname === '/support') return;
		window.scrollTo(0, 0);
	}, [location]);

	return null;
}

export default ScrollToTop;
